import { useEffect, useState } from "react";
import { useLazyGetAllHealthEventsQuery } from "../api/healthEventApi";
import { HealthEventCalendar } from "../views/HealthEventsCalendar";
import { useTranslation } from "react-i18next";

export const HealthUserEvents = ({
    userGuid,
    onEventClick
}) => {

    const [t] = useTranslation(["global", "health"]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [fetchEvents, {
        data: healthEvents,
        isFetching: isFetching,
        isSuccess: isSuccess,
    }] = useLazyGetAllHealthEventsQuery();

    useEffect(() => {
        if (startDate && endDate)
            fetchEvents({ start: startDate, end: endDate, userGuid: userGuid }); // Ricarica i dati quando le date cambiano
    }, [startDate, endDate]);

    const handleMonthChange = (start, end) => {
        console.log("MonthChanged")
        setStartDate(new Date(start).getTime());
        setEndDate(new Date(end).getTime());
    };

    return (<div className="card bg-black bg-opacity-10 text-white mb-5 mt-2">
        <div className={`card-body text-center ${isFetching && "opacity-25"}`}>
            <h4><i className="fa-solid fa-calendar-days"></i> {t("health:menu.events_log_ext")}</h4>
            <HealthEventCalendar
                healthEvents={healthEvents}
                showUser = {false}
                onDataChange={handleMonthChange}
                onEventClick={onEventClick}
            />
        </div>
    </div>)

}